<template>
	<div class="con">
		<div class="head">
			<van-tabs v-model="headActive" color="#27bec4" @change="headBtn">
				<van-tab title="未结算"></van-tab>
				<van-tab title="结算完成"></van-tab>
			</van-tabs>
		</div>
		<div class="list-body" v-show="list.length != 0">
			<div class="list" v-for="(item,index) in list" @click="">
				<div class="list-con">
					<label>就 诊 人：</label>
					<div class="name">{{item.BRXM}}</div>
				</div>
				<div class="list-con">
					<label>医生：</label>
					<div class="time">{{item.YGXM}}</div>
				</div>
				<div class="list-con">
					<label>科室：</label>
					<div class="time">{{item.KSMC}}</div>
				</div>
				<div class="list-con">
					<label>时间：</label>
					<div class="time">{{item.GHSJ}}</div>
				</div>
				<div class="list-con">
					<label>病情说明：</label>
					<div class="diagnosis">{{item.MSZD}}</div>
				</div>
				<div class="queryBtn" @click="prescriBtn(index)">
					<van-icon name="share" size='20' />
					<div>明细</div>
				</div>
				<div>
					<!-- <div class="inspection" @click="InspeBtn(index)">检验清单</div> -->
				</div>
			</div>
		</div>
		<div class="noImg" v-if="noImgShow == true">
			<img src="../assets/404.gif" />
			<div class="no-text">无记录~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'prescriptionList',
		data() {
			return {
				msg: '就诊报告',
				headActive: 0,
				list: [],
				cardUser: '',
				noImgShow: false,
			}
		},
		methods: {
			//挂号处方查询
			//type 1、挂号没完成 2、挂号已经完成
			register() {
				this.noImgShow = false;
				this.$store.commit('Load', true)
				let num = this.headActive + 1;
				this.$Axios.Get('/outpatient/register?brid=' + this.cardUser.brid + '&type=' + num, null).then(data => {
					this.$store.commit('Load', false)
					console.log(data)
					if (data.code == 0) {
						if (data.msg.length != 0) {
							this.list = data.msg;
							this.noImgShow = false;
						} else {
							this.noImgShow = true;
						}

					} else {
						this.list = '';
						this.noImgShow = true;
					}
				}).catch(err => {
					this.noImgShow = true;
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
			//检验清单
			InspeBtn(e) {
				console.log(this.list[e].SBXH)
				this.$router.push({
					path: '/report',
					query: {
						id: this.list[e].SBXH,
						type: 1, //0、住院 1、门诊
					}
				})
			},
			//点击获取列表详情
			prescriBtn(e) {
				console.log(e)
				this.$router.push({
					path: '/prescription',
					query: {
						user: JSON.stringify(this.list[e])
					}
				})
			},
			//顶部导航
			headBtn(e) {
				this.list = [];
				this.headActive = e;
				this.register();
			}
		},
		mounted() {
			if (localStorage.getItem('cardUserInfo') != undefined) {
				this.cardUser = JSON.parse(localStorage.getItem('cardUserInfo'));
			}
			this.register();
		},

	}
</script>

<style scoped>
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}

	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;

	}

	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}

	.list-body {
		flex: 1;
		overflow-y: auto;
	}

	.list {
		position: relative;
		margin: 2px 0;
		padding: 10px;
		font-size: 15px;
		font-weight: 700;
		color: #000;
		background-color: #fff;

	}

	.list-con {
		display: flex;
		margin-bottom: 10px;
	}

	.list-con label {
		width: 100px;
		color: #999;
		text-align: end;
	}

	.list-con div {
		width: 80%;
	}

	.diagnosis {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.queryBtn {
		position: absolute;
		right: 10px;
		top: 10px;
		text-align: center;
		color: #27BEC4;
		font-size: 12px;
	}

	.inspection {
		display: inline;
		padding: 5px 10px;
		border-radius: 5px;
		background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);
		color: #fff;
	}
</style>
